import Config from '../../../config/Config'

export function buildConsentPortalUrl(): string {
  const url = new URL(Config.B2BC_CONSENT_PORTAL_BASE_URL)

  if (Config.B2BC_CONSENT_PORTAL_FLEET_ID) {
    url.searchParams.set('fleetId', Config.B2BC_CONSENT_PORTAL_FLEET_ID)
  }

  url.searchParams.set('redirectUrl', Config.B2BC_CONSENT_PORTAL_REDIRECT_URL)

  return url.toString()
}
